import { formatPhoneNumber, pickPascalOrCamel } from "../../utils/helpers.js";

/**
 * Build toast notices from POST /BusChangeNotification/SendBusChangeNotification.
 * Response: { Primary, FamilyCopy, Message } (PascalCase from the broadcast API).
 */
export function getBusChangeNotificationNotices(response) {
    if (!response || response.error) {
        return [
            {
                text:
                    "Notification could not be sent: " +
                    ((response && response.error) || "Unknown error"),
                type: "warning",
            },
        ];
    }

    const message =
        pickPascalOrCamel(response, "Message", "message") ||
        "Bus change notification sent successfully.";
    const primary = pickPascalOrCamel(response, "Primary", "primary");
    const familyCopy = pickPascalOrCamel(response, "FamilyCopy", "familyCopy");

    const primaryType = primary
        ? String(pickPascalOrCamel(primary, "Type", "type") || "").toUpperCase()
        : "";
    const primaryLabel =
        primaryType === "CALL" ? "Call" : primaryType === "SMS" ? "SMS" : "";

    let successText = message;
    if (primaryLabel) {
        const trimmed = String(message)
            .replace(/\s+$/, "")
            .replace(/\.$/, "");
        successText = trimmed + " (" + primaryLabel + ").";
    }

    if (familyCopy) {
        const sent = pickPascalOrCamel(familyCopy, "Sent", "sent");
        if (sent) {
            const type = String(
                pickPascalOrCamel(familyCopy, "Type", "type") || ""
            ).toUpperCase();
            const to = pickPascalOrCamel(familyCopy, "To", "to") || "";
            const phoneType =
                pickPascalOrCamel(familyCopy, "PhoneType", "phoneType") || "";
            const phone = formatPhoneNumber(String(to)) || to;
            const channel = type === "CALL" ? "Call" : "SMS";
            let familyLine = "Family copy " + channel + " sent";
            if (phone) {
                familyLine += " to " + phone;
            }
            if (phoneType) {
                familyLine += " (" + phoneType + ")";
            }
            successText =
                String(successText).replace(/\.$/, "") + " " + familyLine + ".";
        } else if (sent === false) {
            const reason =
                pickPascalOrCamel(familyCopy, "Reason", "reason") || "not sent";
            return [
                { text: successText, type: "success" },
                {
                    text: "Family copy not sent: " + reason,
                    type: "warning",
                },
            ];
        }
    }

    return [{ text: successText, type: "success" }];
}
